<style lang="scss">
@import "./styles/contact-card.scss";
</style>

<template>
  <div class="contact-card">
    <v-layout row wrap>
      <v-flex class="contact-card-icon-panel" xs2 xl2>
        <OnBoardCrossIcon class="contact-remove-icon" @click.native="onRemoveClick" v-if="!isSleekDirector" />
        <img
          src="/imgs/on-boarding/sleek-face.svg"
          alt=""
          class="contact-sleek-director-logo"
          v-if="isSleekDirector && !isPartnerCompany"
          width="41"
        />
        <OnBoardDirectorAvatarIcon class="contact-director-logo" v-else-if="isSleekDirector && isPartnerCompany" />
        <OnBoardDirectorAvatarIcon class="contact-director-logo" v-if="!isSleekDirector" />
      </v-flex>
      <v-flex xs8 xl9>
        <h3 class="lbl-contact-card-title director">{{ displayName }}</h3>
      </v-flex>
      <v-flex xs2 xl1>
        <v-btn
          class="btn-contact-card-toggle"
          icon
          @click="isAdditionalDetailsVisible = !isAdditionalDetailsVisible"
          v-if="!isSleekDirector"
        >
          <v-icon>{{ isAdditionalDetailsVisible ? "keyboard_arrow_down" : "keyboard_arrow_up" }}</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-slide-y-transition>
      <v-card-text v-show="isAdditionalDetailsVisible">
        <div class="additional-details-title">{{ this.$t("$company.organization.contact_information") }}</div>
        <p class="additional-details-subtitle" v-if="contact.phone">
          {{ this.$t("$company.organization.mobile_number") }}
        </p>
        <div class="additional-details-content" v-if="contact.phone">+{{ contact.phone }}</div>
        <p class="additional-details-subtitle" v-if="contact.email">{{ this.$t("$company.organization.email") }}</p>
        <div class="additional-details-content">
          {{ contact.email }}
          <v-tooltip v-model="showTooltip" top>
            <v-icon slot="activator" small @click="copyToClipboard('#copy-email' + contact.id)">file_copy</v-icon>
            <span>{{ tooltipText }}</span>
          </v-tooltip>
          <input type="hidden" :id="`copy-email` + contact.id" :value="contact.email" />
        </div>
      </v-card-text>
    </v-slide-y-transition>
  </div>
</template>

<script>
// Icons
import OnBoardDirectorAvatarIcon from "@shared-icons/OnBoardDirectorAvatarIcon.vue";
import OnBoardCrossIcon from "@shared-icons/OnBoardCrossIcon.vue";
// Mixins
import { CopyToClipboardMixin } from "@/mixins/copyToClipboard";
// Utils
import { isPartner } from "@/utilities/partner-util";
import { Constants } from "customer-sdk/constants";

const ON_BOARDING_CONTACTS_EVENTS = Constants.ON_BOARDING_CONTACTS_EVENTS;
//#region Private Methods
let publishContactRemoved = component => {
  let { contactsTopic, contact } = component;

  if (contactsTopic) {
    contactsTopic.publish({
      type: ON_BOARDING_CONTACTS_EVENTS.ON_CONTACT_REMOVED,
      contactCategory: component.contactCategory,
      cardId: component.cardId,
      data: {
        id: contact.id,
        isOwner: contact.isOwner,
        contactType: contact.contactType
      }
    });
  }
};
//#endregion

export default {
  name: "ContactCard",
  mixins: [CopyToClipboardMixin],
  components: {
    OnBoardDirectorAvatarIcon,
    OnBoardCrossIcon
  },
  props: {
    contact: Object,
    isSleekDirector: {
      type: Boolean,
      default: false
    },
    contactsTopic: Object,
    contactCategory: String,
    cardId: Number
  },
  async mounted() {
    let component = this;
    component.isPartnerCompany = await isPartner();
  },
  computed: {
    displayName() {
      let component = this;
      let contact = component.contact;

      if (contact && contact.companyName) {
        return contact.companyName;
      }

      return component.isPartnerCompany && contact.isNomineeDirector
        ? `${contact.lastName}`
        : `${contact.firstName} ${contact.lastName}`;
    },
    isEmailAvailable() {
      let component = this;

      if (component.contact && component.contact.email) {
        return true;
      }

      return false;
    }
  },
  data: function() {
    return {
      isAdditionalDetailsVisible: false,
      isPartnerCompany: false
    };
  },
  methods: {
    onRemoveClick: async function() {
      publishContactRemoved(this);
    }
  }
};
</script>
